module.exports = __webpack_public_path__ + "static/img/btn_ok.b4a2b7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/btn_ok.png
// module id = tHnT
// module chunks = 1